var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import './App.css';
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { LoginCallback, Security, withOktaAuth } from "@okta/okta-react";
import { Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import HomePage from './pages/homePage/homePage';
import AuthRequired from './components/secureRoute/secureRoute';
import GuideTab from './pages/guide/guide';
import SourcesAnddisclimersTab from './pages/sources&disclimers/sourcesAndDisclimers';
import Research from './pages/research/research';
import MarketNews from './pages/marketNews/marketNews';
import ClientTab from './pages/client/client';
import { getApplicationConfig } from './constants/utilities';
import { Provider } from 'mobx-react';
import rootStore from './store';
import RatingAndNotification from './pages/ratingNotification/ratingNotification';
import RecentChanges from './pages/recentChanges/recentChanges';
import Notification from './shared/Notification/Notification';
import MarketDetails from './pages/MarketDetails/MarketDetails';
import { getOktaToken, isInternaluser } from './api/auth/okta';
import { ErrorPage } from './pages/Common/ErrorPage';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { ClientSideRowModelModule } from 'ag-grid-community';
var App = function () {
    var searchParams = useSearchParams();
    var location = useLocation();
    var oktaToken = getOktaToken();
    var DocumentGuid = searchParams[0].get("DocumentGuid");
    var DocType = searchParams[0].get("DocType");
    var MarketId = searchParams[0].get("MarketId");
    if (!oktaToken && !location.pathname.includes("callback")) {
        var deeplinkParams = {
            DocumentGuid: DocumentGuid || undefined,
            DocType: DocType || undefined,
            MarketId: MarketId || undefined,
        };
        localStorage.setItem("deeplinkParams", JSON.stringify(deeplinkParams));
    }
    var _a = useState(null), oktaAuth = _a[0], setOktaAuth = _a[1];
    var application = getApplicationConfig();
    useEffect(function () {
        setOktaAuth(new OktaAuth(application.oktaConfig));
    }, []);
    var originalUri = function (_oktaAuth, originalUri) { return __awaiter(void 0, void 0, void 0, function () {
        var relativeUrl;
        return __generator(this, function (_a) {
            relativeUrl = toRelativeUrl(originalUri || "/", window.location.origin);
            window.location.replace(relativeUrl);
            return [2 /*return*/];
        });
    }); };
    function HandleLoginRedirect() {
        var navigation = useNavigate();
        oktaAuth === null || oktaAuth === void 0 ? void 0 : oktaAuth.handleLoginRedirect().then(function () {
            var getdeeplinkParams = localStorage.getItem("deeplinkParams");
            var _navigation = "?";
            if (getdeeplinkParams) {
                getdeeplinkParams = JSON.parse(getdeeplinkParams);
                Object.keys(getdeeplinkParams).forEach(function (key) {
                    _navigation = _navigation + "&".concat(key, "=").concat(getdeeplinkParams[key]);
                });
                navigation('/' + _navigation, { replace: true });
            }
            else {
                navigation('/', { replace: true });
            }
        });
        return React.createElement(LoginCallback, null);
    }
    // Register all Community features
    ModuleRegistry.registerModules([AllCommunityModule, ClientSideRowModelModule]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Provider, { store: rootStore }, oktaAuth ?
            React.createElement(Security, { oktaAuth: oktaAuth, restoreOriginalUri: originalUri },
                React.createElement(Notification, null),
                React.createElement(Routes, null,
                    React.createElement(Route, { path: application.callbackUrl, element: React.createElement(HandleLoginRedirect, null) }),
                    React.createElement(Route, { element: React.createElement(AuthRequired, null) },
                        isInternaluser() && application.applicationId === 1 && React.createElement(Route, { path: "/", element: React.createElement(ClientTab, null) }),
                        (application.applicationId !== 1 || (application.applicationId === 1 && !isInternaluser())) && React.createElement(Route, { path: "/", element: React.createElement(HomePage, null) }),
                        React.createElement(Route, { path: '/Research', element: React.createElement(Research, null) }),
                        React.createElement(Route, { path: '/Market', element: React.createElement(MarketNews, null) }),
                        application.applicationId !== 3 ? React.createElement(Route, { path: '/Ratings', element: React.createElement(RatingAndNotification, null) }) : null,
                        application.applicationId === 3 ? React.createElement(Route, { path: '/recent-changes', element: React.createElement(RecentChanges, null) }) : null,
                        React.createElement(Route, { path: '/Guides', element: React.createElement(GuideTab, null) }),
                        React.createElement(Route, { path: '/Sources', element: React.createElement(SourcesAnddisclimersTab, null) }),
                        React.createElement(Route, { path: '/market-details', element: React.createElement(MarketDetails, null) }),
                        React.createElement(Route, { path: "/error", element: React.createElement(ErrorPage, null) })))) : null)));
};
export default withOktaAuth(App);
